module.exports = __webpack_public_path__ + "img/13.ce9dcd81.png";